import React from 'react';

function PageLoader() {
    return (
        <div className="flex items-center justify-center py-24">
            <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
    );
}

export default PageLoader;
